import { useApiClient } from '../context/AppContext'
import IResourceLoader from '../types/IResourceLoader'
import useCallbackRef from './useCallbackRef'
import useResourceLoader from './useResourceLoader'
import { FetchEnforcementContacts, IEnforcementContactsData, ILoadEnforcementContacts } from '../types'
import reportsApi from '../api/reportsApi'

const useEnforcementContacts = (): [IResourceLoader<IEnforcementContactsData>, ILoadEnforcementContacts] => {
  const apiClient = useApiClient()

  const resource = useResourceLoader<IEnforcementContactsData>(
    'Unable to load enforcement contacts'
  )

  const loader = useCallbackRef<FetchEnforcementContacts>(
    async (storeCode: string, page: number, type?: string | null): Promise<IEnforcementContactsData> => {
      return resource.load(async () =>
        reportsApi.GetReports(apiClient, storeCode, page, type || null) as Promise<IEnforcementContactsData>
      )
    }
  )

  return [resource, loader]
}

export default useEnforcementContacts
